/***
 * 创建人：李珊
 * 时间：2022-12-29
 * 描述:图像标记管理页面
 * 更新说明:
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SwMassageConfirmComponent } from '../../../../../librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { PlatformLocation } from '@angular/common';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { environment } from 'src/environments/environment';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { KmsEnum } from '../../../serves/kms-enum';
import { KmsFileUploaderBoxComponent } from '../../../components/kms-file-uploader/kms-file-uploader-box/kms-file-uploader-box.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
declare let $: any;
@Component({
    selector: 'app-img-mark-query',
    templateUrl: './img-mark-query.component.html',
    styleUrls: ['./img-mark-query.component.css']
})
export class ImgMarkQueryComponent implements OnInit {
    // 重命名弹框
    @ViewChild('renameModal') renameModal: SwModalframeComponent;
    // 批量驳回弹框
    @ViewChild('batchRejectionModal') batchRejectionModal: SwModalframeComponent;
    // 指派弹框
    @ViewChild('appointModal') appointModal: SwModalframeComponent;
    // 分配质检员弹框
    @ViewChild('assignAuditorModal') assignAuditorModal: SwModalframeComponent;
    // 导出质检记录弹框
    @ViewChild('exportRecordModal') exportRecordModal: SwModalframeComponent;
    // 表格组件
    @ViewChild("swtable") swtable: SwGridTableComponent;
    // 删除确认组件
    @ViewChild("tirm1") tirm1: SwMassageConfirmComponent;
    // 是否显示内容
    isLoading = true;
    // 实体表格搜索数据集合
    searchDatas = {
        isQueryMark: null,     // 是否包含标记
        materialTitle: '',      // 资源名称
        approvalStatus: null,  // 状态
        createUserId: '',      // 创建人
        editorUserId: '',      // 责任编辑
        checkUserId: '',      // 当前质检员
        onlyMe: false,         // 只看我的
    }
    // 状态选项
    auditStatus = [
        { id: 6, text: '全部' }, { id: 0, text: '待指派' }, { id: 1, text: '待编辑' }, { id: 2, text: '待分配质检' },
        { id: 3, text: '待质检' }, { id: 4, text: '待发布' }, { id: 5, text: '已发布' }
    ];
    // 创建人选项
    creatorOptions: any = [];
    // 编辑人员选项
    editorOptions: any = [];
    // 知识质检人员选项
    auditorOptions: any = [];
    // 是否包含标记选项
    isQueryMarkOptions = [{ id: 2, text: '全部' }, { id: 1, text: '是' }, { id: 0, text: '否' }];
    // 用户角色
    userRole = '';
    // 用户id
    userId = '';
    // 表格操作按钮
    toolbarArr = [
        ["upload", "apply", "appoint", "submit", "assignAuditor", "batchRejection", "publish", "republish", "export"],
        ["autoMark", "mark", "view","modify", "verify"],
        // ["autoMark", "S28_MA050201", "view","modify", "verify"],
    ];
    toolbar = [[], []];
    // 右侧实体表格数据
    imgDatas = [];
    // 右侧表格分页组件
    pageBase = {
        current: 1,
        size: 10
    }
    // 右侧表格选中行数据
    selectedDatas = [];
    // 批量驳回备注
    rejectionRemark = '';
    // 指定的责任编辑
    editorUserId = '';
    // 指定的质检人员(分配质检员时)
    auditorUserId = '';
    // 指定的质检人员(导出质检记录时)
    auditorUserId1 = '';
    auditTime = '';
    // 选中图像数据（重命名时）
    renameData:any = {};
    //默认展示的列
    filterDatas: any = {
        filePath: true,
        materialTitle: true,
        type: true,
        approvalStatus: true,
        createUserName: true,
        editorUserName: true,
        checkUserName: true,
        allCheckUserName: false,
        createDate: true,
        editStartTime: false,
        checkCommitTime: false,
        checkTime: false,
        publishUserName: false,
        publishTime: true,
    };
    //筛选dropdown数据
    filterDatasArray: any = [
        { id: "filePath", text: "缩略图" },
        { id: "materialTitle", text: "资源名称" },
        { id: "type", text: "图像类型" },
        { id: "approvalStatus", text: "状态" },
        { id: "createUserName", text: "创建人" },
        { id: "editorUserName", text: "责任编辑" },
        { id: "checkUserName", text: "当前质检员" },
        { id: "allCheckUserName", text: "所有质检员" },
        { id: "createDate", text: "创建时间" },
        { id: "editStartTime", text: "任务开始时间" },
        { id: "checkCommitTime", text: "提交质检时间" },
        { id: "checkTime", text: "质检时间" },
        { id: "publishUserName", text: "发布人" },
        { id: "publishTime", text: "发布时间" },
    ];
    typeOptions:any = [];
    // 是否查看大图
    showBigImg = false;
    filePath = '';
    constructor(
        private dicService: DictionaryService,
        private create: SwCreateModalComponentService,
        private location: PlatformLocation,
        private routeInfo: ActivatedRoute,
        private jwt: SwJwtService,
        private User: GetUserModelService, //获取用户服务
        private http: SwHttpClientService,
        private kmsService: KmsService,
        private message: SwMassageBoxService,
        private swMaskService: SwMaskService,
        private router: Router
    ) { }

    ngOnInit() {
        // 获取按钮权限
        this.queryToolbarBtns();
        // 获取用户id
        let user = this.User.getUser();
        this.userId = user['userId'];
        // 获取用户角色
        this.userRole = this.jwt.getToken('userRole');
        this.getAllUsers();
        // 根据当前用户角色设置只看我的
        this.setOnlyMe();
        // 获取路由参数
        this.routeInfo.queryParams.subscribe((data: Params) => {
            if (data['selectedData']) {
                const params = JSON.parse(data['selectedData']);
                this.searchDatas.approvalStatus = params.approvalStatus;
            }
            // 查询实体列表
            this.getImgDatas();
        });
        // 获取图像类型字典
        this.typeOptions = this.dicService.getDictionaryTree(KmsEnum.KGS_IMAGE_TYPE_OPTION,'dictionaryId','dictionaryName','parentId','dictionaryValue');
        let options = JSON.parse(JSON.stringify(this.typeOptions));
        this.typeOptions.forEach(element => {
            let item = options.filter(el => el.id == element['pid']);
            element['pid'] = item.length>0 ? item[0].value : '0';
            element['parentId'] = element['pid'];
            element['id'] = element['value'];
        });
    }

    // 查询工具按钮列表
    queryToolbarBtns() {
        // 根据路径去查询配置的按钮
        let pathname = ["/", "", ""]
        try {
            pathname = this.location["location"].hash.split('?')[0].split("/");
        } catch (e) {

        }
        let systemId = this.jwt.getToken("systemId")
        // 准备拼接url
        let url = environment.seekerWebAPI + "function/queryButtonsByUri"
        // 要去掉#，故第一个参数不使用
        if (pathname.length > 1) {
            // 拼接uri
            url = url + "?uri=";
            for (let index = 1; index < pathname.length; index++) {
                url = url + "/" + pathname[index]
            }
        }
        // 拼接系统ID参数
        url = url + "&systemId=" + systemId;
        this.http.Post(url, {}).subscribe(data => {
            if (data.code == '200') {
                data.data.forEach((element) => {
                    if (
                        this.toolbarArr[0].filter((item) => item == element.functionCode)
                            .length > 0
                    ) {
                        this.toolbar[0].push({
                            status: true,
                            functionCode: element.functionCode,
                            functionName: element.functionName,
                            icon: element.icon,
                            children: [],
                        });
                    }
                    if (
                        this.toolbarArr[1].filter((item) => item == element.functionCode)
                            .length > 0
                    ) {
                        this.toolbar[1].push({
                            status: true,
                            functionCode: element.functionCode,
                            functionName: element.functionName,
                            icon: element.icon,
                            children: [],
                        });
                    }
                });
            } else {
                this.message.waring('当前用户按钮组权限获取失败！');
            }
        });
    }

    // 根据当前用户角色设置只看我的
    setOnlyMe() {
        if (this.userRole == '知识编辑') {
            this.searchDatas.onlyMe = true;
            this.searchDatas.editorUserId = this.userId;
        }
        if (this.userRole == '知识质检') {
            this.searchDatas.onlyMe = true;
            this.searchDatas.checkUserId = this.userId;
        }
    }

    // 选中或取消选中只看我的
    onlyMeChange() {
        if (this.searchDatas.onlyMe) {
            if (this.userRole == '知识编辑') {
                this.searchDatas.editorUserId = this.userId;
            }
            if (this.userRole == '知识质检') {
                this.searchDatas.checkUserId = this.userId;
            }
        } else {
            if (this.userRole == '知识编辑') {
                this.searchDatas.editorUserId = '';
            }
            if (this.userRole == '知识质检') {
                this.searchDatas.checkUserId = '';
            }
        }
        this.handleSearchClick();
    }

    // 表格选中行数据（只根据数据状态判断是否可以进行操作，至于什么角色能够操作由角色权限控制）
    handleSelectData(event) {
        // 获取当前选中的所有数据
        this.selectedDatas = event;
        // 设置按钮组全部启用
        this.swtable.toolbarAllEnable();
        // 未选中任何数据时，启用新增、导出质检记录按钮
        if (this.selectedDatas.length <= 0) {
            this.swtable.toolbarAllDisable();
            this.swtable.enableToobar('upload');
            this.swtable.enableToobar('export');
        } else {
            // 禁用批量删除按钮：选中数据中存在已发布的
            let publishedLen = this.selectedDatas.filter(el => el.approvalStatus == 5).length;
            if(publishedLen > 0){
                this.swtable.disableToolbar('batchDelete');
            }
            // 禁用申领按钮：选中数据中存在不是待指派的
            let notAppointLen = this.selectedDatas.filter(el => el.approvalStatus != 0).length;
            if (notAppointLen > 0) {
                this.swtable.disableToolbar('apply');
            }
            // 禁用指派按钮：选中数据中存在不是待指派、待分配质检、待编辑、待发布的
            let notAppointLen1 = this.selectedDatas.filter(el => el.approvalStatus != 0 && el.approvalStatus != 1 && el.approvalStatus != 2 && el.approvalStatus != 4).length;
            if (notAppointLen1 > 0) {
                this.swtable.disableToolbar('appoint');
            }
            // 禁用提交质检按钮： 选中数据中存在不是待编辑的 或 责任编辑不是当前登录用户的
            let notEditLen = this.selectedDatas.filter(el => el.approvalStatus != 1).length;
            let notEditorLen = this.selectedDatas.filter(el => el.editorUserId != this.userId).length;
            if (notEditLen > 0 || notEditorLen > 0) {
                this.swtable.disableToolbar('submit');
            }
            // 禁用分配质检员按钮：选中数据中存在不是待分配质检 和 待发布的
            let notAssignLen = this.selectedDatas.filter(el => el.approvalStatus != 2 && el.approvalStatus != 4).length;
            if (notAssignLen > 0) {
                this.swtable.disableToolbar('assignAuditor');
            }
            // 禁用批量驳回按钮：选中数据中存在不是待质检的 或  实体的当前质检员不是当前登录用户的
            let notVerifyLen = this.selectedDatas.filter(el => el.approvalStatus != 3).length;
            let notAuditorLen = this.selectedDatas.filter(el => el.checkUserId != this.userId).length;
            if (notVerifyLen > 0 || notAuditorLen > 0) {
                this.swtable.disableToolbar('batchRejection');
            }
            // 禁用发布按钮：选中数据中存在不是待发布的
            let notPublishLen = this.selectedDatas.filter(el => el.approvalStatus != 4).length;
            if (notPublishLen > 0) {
                this.swtable.disableToolbar('publish');
            }
            // 禁用撤销发布按钮：选中数据中存在不是已发布的
            let notPublishedLen = this.selectedDatas.filter(el => el.approvalStatus != 5).length;
            if (notPublishedLen > 0) {
                this.swtable.disableToolbar('republish');
            }
        }
    }

    // 表格分页点击方法
    handlePageClick(event) {
        this.pageBase = event;
        this.getImgDatas();
    }

    // 获取实体表格列表数据
    getImgDatas() {
        this.isLoading = true;
        this.selectedDatas = [];
        let Params = {
            current: this.pageBase.current,
            size: this.pageBase.size,
            materialCategory: 'FILE_TYPE_PICTURE',
            materialTitle: $.trim(this.searchDatas.materialTitle),
            approvalStatus: this.searchDatas.approvalStatus == 6 ? null : this.searchDatas.approvalStatus,
            isQueryMark: this.searchDatas.isQueryMark == 2 ? null : this.searchDatas.isQueryMark,
            editorUserId: this.searchDatas.editorUserId,
            checkUserId: this.searchDatas.checkUserId,
            createUserId: this.searchDatas.createUserId
        };
        this.kmsService.queryMaterialListByParams(Params).subscribe(
            result => {
                this.isLoading = false;
                if (result.code == 200) {
                    this.imgDatas = [];
                    this.pageBase = result.data;
                    this.imgDatas = result.data.records;
                    this.imgDatas.forEach(item => {
                        if (item.fileThumbnail) {
                            item["src"] = environment.staticFileUrl + item.fileThumbnail;
                        } else if (item.filePath) {
                            item["src"] = environment.staticFileUrl + item.filePath;
                        }
                    })
                } else {
                    this.message.waring(result.msg);
                }
            }
        );
    }

    // 监听输入框enter键搜索
    handelEnterSearch(event) {
        if (event.keyCode == 13) {
            this.handleSearchClick();
        }
    }

    // 搜索实体
    handleSearchClick() {
        this.pageBase = {
            current: 1,
            size: 10
        }
        this.getImgDatas();
    }

    // 右侧搜索重置按钮
    handleReloadClick() {
        this.pageBase = {
            current: 1,
            size: 10
        }
        this.searchDatas = {
            isQueryMark: null,          // 是否包含标记
            materialTitle: '',      // 资源名称
            approvalStatus: null,  // 状态
            createUserId: '',      // 创建人
            editorUserId: '',      // 责任编辑
            checkUserId: '',      // 当前质检员
            onlyMe: false         // 只看我的
        }
        this.getImgDatas();
    }

    // 按钮点击事件
    handleOperationClick(event) {
        switch (event) {
            case "upload": this.handleUploadClick(); break;            // 上传
            case "apply": this.handleApplyClick(); break;              // 申领
            case "appoint": this.handleAppointClick(); break;          // 指派
            case "submit": this.clickSubmit(); break;                 // 提交质检
            case "assignAuditor": this.clickAssignAuditor(); break;   // 分配质检员
            case "batchRejection": this.clickBatchRejection(); break; // 批量驳回
            case "publish": this.clickPublish(); break;               // 批量发布
            case "republish": this.clickRepublish(); break;           // 撤销发布
            case "export": this.clickExport(); break;                 // 导出质检记录
        }
    }

    /**
     * 点击td中的按钮
     * @ignore
     */
    clickTdBtn(type, data) {
        //禁止冒泡
        event.stopPropagation();
        // 标记
        // if(type == 'S28_MA050201') {
        if (type == 'mark') {
            data["mode"] = 'edit';
            this.router.navigate(["/kms/ResourcesMark"], {
                queryParams: { Title: "编辑图像标记", selectedData: JSON.stringify(data) },
            });
        }
        // 查看
        else if (type == "view") {
            data["mode"] = 'view';
            this.router.navigate(["/kms/ResourcesMark"], {
                queryParams: { Title: "查看图像标记", selectedData: JSON.stringify(data) },
            });
        }
        // 质检
        else if (type == "verify") {
            data["mode"] = 'verify';
            this.router.navigate(["/kms/ResourcesMark"], {
                queryParams: { Title: "审核图像标记", selectedData: JSON.stringify(data) },
            });
        }
        // 重命名
        else if(type == 'modify'){
            this.renameData = JSON.parse(JSON.stringify(data));
            this.renameModal.toggle();
        }
        // 自动标记
        else if(type == 'autoMark'){
            const materialId = data.materialId;
            if(data.markNum){
                this.tirm1.openCLick('该图像已存在标记信息，请确认是否继续执行自动标记操作？', (data) => {
                    if (data) {
                        this.handleAutoMarkClick(materialId);
                    }
                });
            }else{
                this.handleAutoMarkClick(materialId);
            }
        }
    }

    // 自动标记
    handleAutoMarkClick(materialId){
        let params = {
            "material_id": materialId,
        }
        this.swMaskService.openMask("正在进行图像切割,请稍等...");
        this.kmsService.autoGetImgMarks(params).subscribe(res => {
            this.swMaskService.closeMask();
            if (res.code == '200') {
                this.message.info('操作成功！');
                this.getImgDatas();
            } else {
                this.message.waring('操作失败！');
            }
        })
    }

    // 上传
    handleUploadClick() {
        // 通过知识库标识拼接文件策略
        let kgDbInfo = JSON.parse(this.jwt.getToken("kgDbInfo"));
        let kgCode = kgDbInfo && kgDbInfo.englishCode ? kgDbInfo.englishCode : "";
        let fileCode = kgCode
            ? KmsEnum.KMS_INSTANCE_IMG_RESOURCE + "_" + kgCode.toUpperCase()
            : "";

        let uploadParams = {
            label3: "filePicker", //根据 label3 确定上传组件的 id
            fileCode: fileCode, //根据 fileCode 查询策略
            fileBusinessId: "", //根据 fileCode 和 fileBusinessId 查询已上传文件,如果此值为空，就根据下面的 fileInfoIds 来查
            fileInfoIds: [], //根据 fileInfoIds 也可以查询已上传文件
            closeDisabled: true, //根据此值决定上传模态框中右上角的 × 是否消失
            isUploadResource: true  //是否上传资源
        };
        this.create.createModal(
            KmsFileUploaderBoxComponent,
            uploadParams,
            this.uploadCallback.bind(this)
        );
    }

    /**
   * 上传完成后的回调
   * @ignore
   */
    uploadCallback(event) {
        // event.addList 需保存的资源信息； event.instanceInfo 需关联的实体信息
        let files = event.list.addList;
        let resourceParams = event.resourceParams;
        if (files) {
            let params = [];
            files.forEach((element) => {
                let thumbnailPath = "";
                if (element.fileType == "FILE_TYPE_PICTURE") {
                    let index = element.fileName.lastIndexOf(".");
                    let name =
                        element.fileName.substring(0, index) +
                        "_300@x." +
                        element.fileSuffix;
                    thumbnailPath = element.filePath + "THUMB/" + name;
                }
                let arr = element.fileOldname.split(".");
                let fileName = "";
                for (let i = 0; i < arr.length - 1; i++) {
                    if (i == arr.length - 2) {
                        fileName += arr[i];
                    } else {
                        fileName += arr[i] + ".";
                    }
                }
                let category = this.isNotTiff(element.fileName)
                    ? element.fileType
                    : "FILE_TYPE_PICTURE";
                let entity = {
                    fileId: element.fileInfoId,
                    fileSuffix: element.fileSuffix,
                    materialTitle: fileName,
                    filePath: element.filePath + element.fileName,
                    materialCategory: category,
                    fileThumbnail: thumbnailPath,
                    accessType: 1,
                    approvalStatus: 0,
                    currentUserRole: this.userRole == '知识编辑' ? 1 : 2,
                    status: 0,
                    textExtractStatus: 0,
                    catalogId: resourceParams.catalogId,
                    docType: resourceParams.docType,
                };
                params.push(entity);
            });
            // 保存资源信息
            this.kmsService.saveOrUpdateMaterial(params).subscribe((data) => {
                if (data.code == "200") {
                    this.message.info('操作成功！');
                    this.updateESMaterialInfo(data.data);
                    this.handleSearchClick();
                } else {
                    this.message.waring(data.msg);
                }
            });
        }
    }

    // 更新资源es信息
    updateESMaterialInfo(ids){
        if(ids.length == 0){
            return;
        }
        this.kmsService.updateESMaterialInfo({"materialIdList":ids}).subscribe(
            data => {
                if (data["code"] != 200) {
                    this.message.danger(data.msg);
                }
            }
        )
    }

    isNotTiff(path) {
        if (path && (path.indexOf(".tif") >= 0 || path.indexOf(".tiff") >= 0)) {
            return false;
        } else {
            return true;
        }
    }

    // 申领
    handleApplyClick() {
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        let ids = this.selectedDatas.map(v => v.materialId);
        let params = {
            "dataIds": ids,
            "status": 1
        }
        this.kmsService.batchUpdateImgEditorAndCheckUser(params).subscribe(res => {
            if (res.code == '200') {
                this.message.info('操作成功！');
                this.getImgDatas();
            } else {
                this.message.waring(res.msg);
            }
        })
    }

    // 指派
    handleAppointClick() {
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.editorUserId = '';
        this.appointModal.toggle();
    }

    // 提交质检
    clickSubmit() {
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.tirm1.openCLick('请确认是否将当前选中的数据提交质检？', (data) => {
            if (data) {
                let ids = this.selectedDatas.map(v => v.materialId);
                let params = {
                    "approvalStatus": 2,
                    "idList": ids
                }
                this.kmsService.batchUpdateImgStatus(params).subscribe(res => {
                    if (res.code == '200') {
                        this.message.info('操作成功！');
                        this.getImgDatas();
                    } else {
                        this.message.waring(res.msg);
                    }
                })
            }
        });
    }

    // 分配质检员
    clickAssignAuditor() {
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.auditorUserId = '';
        this.assignAuditorModal.toggle();
    }

    // 批量驳回
    clickBatchRejection() {
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.rejectionRemark = '';
        this.batchRejectionModal.toggle();
    }

    // 发布
    clickPublish() {
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.tirm1.openCLick('请确认是否将当前选中的数据进行发布？', (data) => {
            if (data) {
                let ids = this.selectedDatas.map(v => v.materialId);
                let params = {
                    "approvalStatus": 5,
                    "idList": ids
                }
                this.kmsService.batchUpdateImgStatus(params).subscribe(res => {
                    if (res.code == '200') {
                        this.message.info('操作成功！');
                        this.getImgDatas();
                    } else {
                        this.message.waring(res.msg);
                    }
                })
            }
        });
    }

    // 撤销发布
    clickRepublish() {
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.tirm1.openCLick('请确认是否将当前选中的数据撤销发布？', (data) => {
            if (data) {
                let ids = this.selectedDatas.map(v => v.materialId);
                let params = {
                    "approvalStatus": 4,
                    "idList": ids
                }
                this.kmsService.batchUpdateImgStatus(params).subscribe(res => {
                    if (res.code == '200') {
                        this.message.info('操作成功！');
                        this.getImgDatas();
                    } else {
                        this.message.waring(res.msg);
                    }
                })
            }
        });
    }

    // 导出质检记录
    clickExport() {
        this.auditorUserId1 = '';
        this.auditTime = '';
        this.exportRecordModal.toggle();
    }

    // 确定操作
    sure(state) {
        let ids = this.selectedDatas.map(v => v.materialId);
        // 指派
        if (state == 'appoint') {
            let userName = this.editorOptions.filter(el => el.id == this.editorUserId)[0].text;
            let params = {
                "dataIds": ids,
                "status": 1,
                "userId": this.editorUserId,
                "userName": userName
            }
            this.kmsService.batchUpdateImgEditorAndCheckUser(params).subscribe(res => {
                if (res.code == '200') {
                    this.message.info('操作成功！');
                    this.getImgDatas();
                    this.appointModal.toggle();
                } else {
                    this.message.waring(res.msg);
                }
            })
        }
        // 分配质检员
        if (state == 'assignAuditor') {
            let userName = this.auditorOptions.filter(el => el.id == this.auditorUserId)[0].text;
            let params = {
                "dataIds": ids,
                "status": 3,
                "userId": this.auditorUserId,
                "userName": userName
            }
            this.kmsService.batchUpdateImgEditorAndCheckUser(params).subscribe(res => {
                if (res.code == '200') {
                    this.message.info('操作成功！');
                    this.getImgDatas();
                    this.assignAuditorModal.toggle();
                } else {
                    this.message.waring(res.msg);
                }
            })
        }
        // 批量驳回
        if (state == 'rejection') {
            let ids = this.selectedDatas.map(v => v.materialId);
            let params = {
                "approvalStatus": 1,
                "idList": ids,
                "remark": this.rejectionRemark
            }
            this.kmsService.batchUpdateImgStatus(params).subscribe(res => {
                if (res.code == '200') {
                    this.message.info('操作成功！');
                    this.getImgDatas();
                    this.batchRejectionModal.toggle();
                } else {
                    this.message.waring(res.msg);
                }
            })
        }
        // 导出质检记录
        if (state == 'exportRecord') {
            let startTime = '', endTime = '';
            if (this.auditTime) {
                startTime = this.auditTime.split('#')[0],
                    endTime = this.auditTime.split('#')[1]
            }
            const params = {
                "recordType": 1,  // 实体质检记录：0，图像标记质检记录：1
                "userId": this.auditorUserId1,
                "startTime": startTime,
                "endTime": endTime
            }
            this.kmsService.exportCheckRecord(params);
            this.exportRecordModal.toggle();
        }
        // 重命名
        if (state == 'rename') {
            const params = {
                materialId: this.renameData.materialId,
                materialTitle: this.renameData.materialTitle,
                type: this.renameData.type
              }
              this.kmsService.saveMaterialInfo(params).subscribe(
                res => {
                    if (res.code == '200') {
                        this.message.info('操作成功！');
                        this.updateESMaterialInfo([this.renameData.materialId]);
                        this.getImgDatas();
                        this.renameModal.toggle();
                    } else {
                        this.message.waring(res.msg);
                    }
                }
              );
        }
    }

    // 取消操作
    cancel(state) {
        if (state == 'rejection') {
            this.batchRejectionModal.toggle();
        }
        if (state == 'appoint') {
            this.appointModal.toggle();
        }
        if (state == 'assignAuditor') {
            this.assignAuditorModal.toggle();
        }
        if (state == 'exportRecord') {
            this.exportRecordModal.toggle();
        }
        if (state == 'rename') {
            this.renameModal.toggle();
        }
    }

    // 判断当前数据的操作权限（只根据数据状态判断是否可以进行操作，至于什么角色能够操作由角色权限控制）
    /* 
        禁用标记按钮：
            1.当前登录用户为超级管理员角色  
            2.当前登录用户为知识库管理员角色且状态为已发布 
            3.当前登录用户为知识编辑角色时，状态不是待编辑或责任编辑不是当前登录用户
            4.当前登录用户为知识质检角色时，状态不是待质检或当前质检员不是当前登录用户
            5.当前登录用户的角色为其他
        禁用质检按钮：状态不是待质检 或 当前登录用户为非知识质检角色  或  当前登录用户不是该实体的当前质检员
    */
    checkDisable(functionCode, data) {
        if (functionCode == 'mark' || functionCode == 'autoMark') {
            if (this.userRole == '超级管理员' || this.userRole == '其他') {
                return true;
            }
            if (this.userRole == '知识库管理员' && data.approvalStatus == 5) {
                return true;
            }
            if (this.userRole == '知识编辑' && (data.approvalStatus !== 1 || this.userId != data.editorUserId)) {
                return true;
            }
            if (this.userRole == '知识质检' && (data.approvalStatus !== 3 || this.userId != data.checkUserId)) {
                return true;
            }
            return false;
        } else if (functionCode == 'modify' || functionCode == 'view') {
            // 查看按钮任何状态下都不禁用
            return false;
        } else if (functionCode == 'verify') {
            // 知识库管理员可以质检所有待质检图像
            if(this.userRole == '知识库管理员'){
                if(data.approvalStatus != 3){
                    return true;
                }else{
                    return false;
                }
            }else{
                // 禁用质检按钮：数据状态不是待质检  或   当前质检员不是登录用户的
                if(data.approvalStatus != 3 || this.userId != data.checkUserId){
                    return true;
                }else{
                    return false;
                }
            }
        }
    }

    // 根据用户所属组织id查询所有用户信息、知识编辑人员、知识质检人员
    getAllUsers() {
        let systemId = this.jwt.getToken("systemId");
        // 获取知识库关联组织id(当前为用户所属组织id，需要进行修改)
        let orgId = this.jwt.getToken('orgId');
        let userParams = {
            entity: {
                systemId: systemId
            },
            organizeId: orgId,
            lazy: true,
            param: {
                systemId: systemId,
                pageNum: 1,
                pageSize: 1000
            }
        }
        this.kmsService.queryUserByOrganizeId(userParams).subscribe(
            data => {
                if (data.code == '200') {
                    let res = data.data && data.data.records ? data.data.records : [];
                    if (res.length > 0) {
                        res.forEach(el => {
                            el['id'] = el['userId'];
                            el['text'] = el['displayName'];
                            let roleList = el['roleList'];
                            if (roleList && roleList.filter(item => item.roleCode.indexOf('_EDITOR') >= 0).length > 0) {
                                this.editorOptions.push(el);
                            } else if (roleList && roleList.filter(item => item.roleCode.indexOf('_AUDITOR') >= 0).length > 0) {
                                this.auditorOptions.push(el);
                            }
                        })
                        this.creatorOptions = res;
                    }
                }
            }
        )
    }

    // 根据标识获取图像类型名称
    getImageTypeName(code){
        if(!code){
            return '无';
        }
        let items = this.typeOptions.filter(el => el.id == code);
        if(items.length>0){
            return '图片（'+items[0].text+'）';
        }else{
            return '无';
        }
    }

    // 查看大图
    viewBigImg(data){
        this.showBigImg = true;
        this.filePath = data.filePath;
        // this.filePath = 'aa3664193b7511eb9cf8000c292fb426kgs/KMS/KMS_INSTANCE_RESOURCE_TESTZSK//20230619/7278dc078a1543dd86b391132efd7600.jpg';
    }
}


